<template>
  <div style="text-align: left; font-size: 0.2rem">
    <ul class="enable-list-type">
      <li>
        存款必须使用{{ tokenStandard }}的方式入金，另外亦需正确汇到我司提供的收款地址，如没有使用该方式或输入错误地址存款，资金将可能遗失（不作补偿）
      </li>
      <li>
        客户如有支付合理矿工费（费用由客户承担），一般会30分钟内到账。如存款当刻有较多笔转账，会按支付
        矿工费 较多的转账先作处理，这情况下到账时间有机会高于30分钟到账
      </li>
      <li>
        一般钱包会有建议的手续费，客户可自行考虑支付多少矿工费
      </li>
      <li>
        客户需自行用自己的钱包买币，
        不论客户是用那一家钱包，只要钱包实际支付的是{{ tokenStandard }}，并且正确汇到用户中心提供收款二维码或复制的地址，支付公司就可接收该笔转账。
      </li>
      <li>
        当客户使用的钱包转账需收矿工费时，一般矿工费会在转账金额中扣取，如交易所账户转账，当余额不足时亦可能会从转账金额中扣取。
      </li>
      <li>
        如用户中心提案入金金额与支付公司实际收款金额不同，或未有于用户中心提交入金操作而入金，可能会引起资金延迟到账，客户可提供入金截图及入金地址供客服为您跟进。
      </li>
      <li>
        请务必确认所使的手机或电脑等设备及浏览器安全，防止信息被篡改或泄露；
      </li>
      <li>
        当您的支付得到网络确认后，存款将自动进入您的交易账户，部分钱包中会显示到账的时间。留意到账时间可能与您支付的矿工费或当前数字货币网络的拥挤程度相关，您可耐心等待，或查看所使用银包是否有加速交易功能，追加矿工费让费用尽快到账。
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'UsdtAlert',
  props: {
    tokenStandard: {
      type: String,
      default: ''
    }
  }
}
</script>
